import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { useLanguage } from '../contexts/LanguageContext';
import '../styles/ThemeModal.css';
import '../styles/DynamicPanel.css';

const ThemeModal = ({ isOpen, onClose }) => {
  const { theme, setTheme } = useTheme();
  const { t } = useLanguage();

  if (!isOpen) return null;

  const handleThemeSelect = (selectedTheme) => {
    setTheme(selectedTheme);
    // Dialog bleibt offen, damit Benutzer mehrere Themes ausprobieren kann
  };

  return (
    <div className="dynamic-panel">
      <div className="panel-header">
        <h2>🎨 {t('selectTheme') || 'Themes'}</h2>
        <button className="close-btn" onClick={onClose}>✕</button>
      </div>
      
      <div className="panel-content">
        <div className="theme-options">
          {/* Blue Galaxy (replaces former Light) */}
          <div
            className={`theme-option ${theme === 'blue-galaxy' ? 'active' : ''}`}
            onClick={() => handleThemeSelect('blue-galaxy')}
          >
            {theme === 'blue-galaxy' && <div className="theme-checkmark">✓</div>}
            <div className="theme-preview light-preview">
              <img src="/images/BlueGalaxyPreview.png" alt="Blue Galaxy Theme Preview" />
            </div>
            <div className="theme-info">
              <h4>🌌 Blue Galaxy</h4>
              <p>Helles, blaues UI</p>
            </div>
          </div>

          {/* GoodVibes */}
          <div
            className={`theme-option ${theme === 'goodvibes' ? 'active' : ''}`}
            onClick={() => handleThemeSelect('goodvibes')}
          >
            {theme === 'goodvibes' && <div className="theme-checkmark">✓</div>}
            <div className="theme-preview goodvibes-preview">
              <img src="/images/GoodVibesPreview.png" alt="GoodVibes Theme Preview" />
            </div>
            <div className="theme-info">
              <h4>😊 GoodVibes</h4>
              <p>Warme, freundliche Farben</p>
            </div>
          </div>

          {/* Power */}
          <div
            className={`theme-option ${theme === 'power' ? 'active' : ''}`}
            onClick={() => handleThemeSelect('power')}
          >
            {theme === 'power' && <div className="theme-checkmark">✓</div>}
            <div className="theme-preview power-preview">
              <img src="/images/PowerPreview.png" alt="Power Theme Preview" />
            </div>
            <div className="theme-info">
              <h4>⚡ Power</h4>
              <p>Kräftige Kontraste</p>
            </div>
          </div>

          {/* PurpleBubbles */}
          <div
            className={`theme-option ${theme === 'purple-bubbles' ? 'active' : ''}`}
            onClick={() => handleThemeSelect('purple-bubbles')}
          >
            {theme === 'purple-bubbles' && <div className="theme-checkmark">✓</div>}
            <div className="theme-preview purple-bubbles-preview">
              <img src="/images/PurpleBubblesPreview.png" alt="Purple Bubbles Theme Preview" />
            </div>
            <div className="theme-info">
              <h4>🫧 PurpleBubbles</h4>
              <p>Lebendige Lila-Töne</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThemeModal;